import React, { useEffect, useState } from 'react';
import { Card, Table, Spinner } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import ApiService from 'helpers/apiService';

const Support = () => {
  const [logsLoading, setLogsLoading] = useState(true);
  const [logs, setLogs] = useState([]);
  const [logsError, setLogsError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLogsLoading(true);
    setLogsError(null);
    ApiService.supportGetLogs()
      .then((data) => {
        if (!cancelled) {
          setLogs(Array.isArray(data) ? data : data ? [data] : []);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          const status = err?.response?.status;
          const msg = status === 501
            ? 'Функционал в разработке'
            : (err?.response?.data?.message || err?.message || 'Ошибка загрузки логов');
          setLogsError(msg);
          setLogs([]);
        }
      })
      .finally(() => {
        if (!cancelled) setLogsLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  const renderLogsContent = () => {
    if (logsLoading) {
      return (
        <div className="d-flex align-items-center gap-2 p-4">
          <Spinner animation="border" size="sm" />
          <span>Загрузка логов...</span>
        </div>
      );
    }
    if (logsError) {
      return (
        <div className={`p-4 ${logsError === 'Функционал в разработке' ? 'text-muted' : 'text-danger'}`}>
          {logsError}
        </div>
      );
    }
    if (!logs.length) {
      return <div className="p-4 text-muted">Нет записей логов</div>;
    }

    const first = logs[0];
    const isObject = first !== null && typeof first === 'object' && !Array.isArray(first);
    const keys = isObject ? Object.keys(first) : [];

    if (isObject && keys.length > 0) {
      return (
        <Table responsive hover size="sm" className="align-middle mb-0" style={{ fontSize: '0.82rem' }}>
          <thead className="table-light">
            <tr>
              <th>#</th>
              {keys.map((k) => (
                <th key={k}>{k}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {logs.map((row, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                {keys.map((k) => (
                  <td key={k}>
                    {row[k] != null && typeof row[k] === 'object'
                      ? JSON.stringify(row[k])
                      : String(row[k] ?? '')}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      );
    }

    return (
      <ul className="list-group list-group-flush">
        {logs.map((item, idx) => (
          <li key={idx} className="list-group-item">
            {typeof item === 'object' ? JSON.stringify(item) : String(item)}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <PageHeader
        title="Поддержка"
        description="Логи и служебная информация"
        className="mb-3"
      />
      <Card>
        <Card.Header>
          <Card.Title className="mb-0">Логи</Card.Title>
        </Card.Header>
        <Card.Body className="p-0">
          {renderLogsContent()}
        </Card.Body>
      </Card>
    </>
  );
};

export default Support;
